export default {
  getCurrentMicroApp: (state) => state.getCurrentMicroApp
};